import { withStyles } from 'vopay';
import SettingsCard from '../SettingsCard/SettingsCard';
import { SettingsItem } from '../types';
import styles from './SettingsOverview.module.scss';

const cn = withStyles(styles);

type SettingsOverviewProps = {
  items: SettingsItem[];
  onSelectItem: (item: SettingsItem) => void;
};

export default function SettingsOverview({ items, onSelectItem }: SettingsOverviewProps) {
  return (
    <div className={cn('cards')}>
      {items.map((item) => (
        <SettingsCard key={item.id} item={item} onClickDetails={() => onSelectItem(item)} />
      ))}
    </div>
  );
}
